import { useState } from 'react';
import './ToolExecutionPanel.css';

const ToolExecutionPanel = ({ toolExecution }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getStatusIcon = () => {
    switch (toolExecution.status) {
      case 'executing':
        return '⏳';
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      default:
        return '⏳';
    }
  };

  const getStatusClass = () => {
    switch (toolExecution.status) {
      case 'executing':
        return 'tool-executing';
      case 'success':
        return 'tool-success';
      case 'error':
        return 'tool-error';
      default:
        return 'tool-executing';
    }
  };

  const formatJson = (obj) => {
    if (!obj) return 'N/A';
    try {
      return JSON.stringify(obj, null, 2);
    } catch {
      return String(obj);
    }
  };

  const getParameterPreview = () => {
    if (!toolExecution.parameters || Object.keys(toolExecution.parameters).length === 0) {
      return null;
    }
    
    const params = toolExecution.parameters;
    const paramCount = Object.keys(params).length;
    
    // Show first parameter or count
    const entries = Object.entries(params);
    if (entries.length === 1) {
      const [key, value] = entries[0];
      const valueStr = typeof value === 'string' ? value : JSON.stringify(value);
      return `${key}: ${valueStr.length > 30 ? valueStr.substring(0, 30) + '...' : valueStr}`;
    } else {
      return `${paramCount} parameters`;
    }
  };

  return (
    <div className={`tool-execution-panel ${getStatusClass()}`}>
      <div 
        className="tool-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="tool-status-icon">{getStatusIcon()}</span>
        <div className="tool-header-content">
          <span className="tool-name">Tool: {toolExecution.toolName}</span>
          {!isExpanded && getParameterPreview() && (
            <span className="tool-param-preview">{getParameterPreview()}</span>
          )}
        </div>
        {toolExecution.status === 'executing' && (
          <span className="tool-executing-indicator">▶</span>
        )}
        <span className={`tool-expand-icon ${isExpanded ? 'expanded' : ''}`}>
          ▼
        </span>
      </div>

      {isExpanded && (
        <div className="tool-details">
          <div className="tool-detail-section">
            <div className="tool-detail-label">Status:</div>
            <div className="tool-detail-value">
              {toolExecution.status === 'executing' ? 'Executing...' : 
               toolExecution.status === 'success' ? 'Completed Successfully' : 
               'Failed'}
            </div>
          </div>

          {toolExecution.parameters && Object.keys(toolExecution.parameters).length > 0 && (
            <div className="tool-detail-section">
              <div className="tool-detail-label">Parameters:</div>
              <pre className="tool-detail-code">
                {formatJson(toolExecution.parameters)}
              </pre>
            </div>
          )}

          {toolExecution.result && (
            <div className="tool-detail-section">
              <div className="tool-detail-label">Result:</div>
              <pre className="tool-detail-code">
                {typeof toolExecution.result === 'string' 
                  ? toolExecution.result 
                  : formatJson(toolExecution.result)}
              </pre>
            </div>
          )}

          {toolExecution.error && (
            <div className="tool-detail-section">
              <div className="tool-detail-label">Error:</div>
              <pre className="tool-detail-code tool-error-text">
                {toolExecution.error}
              </pre>
            </div>
          )}

          <div className="tool-detail-section">
            <div className="tool-detail-label">Timestamp:</div>
            <div className="tool-detail-value">
              {new Date(toolExecution.timestamp).toLocaleTimeString([], { 
                hour: '2-digit', 
                minute: '2-digit',
                second: '2-digit'
              })}
            </div>
          </div>

          {toolExecution.duration && (
            <div className="tool-detail-section">
              <div className="tool-detail-label">Duration:</div>
              <div className="tool-detail-value">
                {toolExecution.duration}ms
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolExecutionPanel;
